export default "__VITE_ASSET__bfb3d91d__"